import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';

import { sendTelemetryErrorEvent } from '~src/commonInfra/components/ErrorBoundary';

import { AppState } from '../../bootstrap/redux/state/AppState';
import { ChannelTypes } from '../../home/types/ChannelTypes';
import {apiPerformanceTimer, HomeApiResult} from '../../home/utils/ApiPerformanceTimer';
import { generateUuid } from '../../home/utils/uuidGenerator';
import WebHttpClient from '../../httpClient/WebHttpClient';
import {
GetAllWorkbookStartersRequest,
GetAllWorkbookStartersResult
} from '../../workbook/ServerApi/requests/starters/GetAllWorkbookTemplatesRequest';
import {
  FetchStarterInfoRequested,
  fetchStarterInfoRequestedAction,
  fetchStartersSucceededAction,
  isFetchStartersInfoRequestedAction
} from '../actions/StartersActions';

export function* rootStartersSaga(): SagaIterator {
  yield takeEvery(fetchStarterInfoRequestedAction, handleGetStartersInfoAction);
}

export const getStartersFromState = (state: AppState) => state.starters;

export function* handleGetStartersInfoAction(action: FetchStarterInfoRequested): SagaIterator {
  try {
    if (isFetchStartersInfoRequestedAction(action)) {
      const uuid = generateUuid();
      const result = yield call(apiPerformanceTimer, fetchStartersWithPerformanceTimer, 'home', ChannelTypes.starters, uuid);
    }
  } catch (e) {
    sendTelemetryErrorEvent(e, { componentStack: 'Accelerators' });
  }
}

export function* fetchStartersWithPerformanceTimer(result: HomeApiResult){
   const startersContent: GetAllWorkbookStartersResult = yield call(sendGetServerStartersInfoRequest);
   yield put(fetchStartersSucceededAction(startersContent));
   result.contentLength = startersContent.workbookTemplates.length;
}

export function sendGetServerStartersInfoRequest(): Promise <GetAllWorkbookStartersResult> {
  const result = WebHttpClient.sendRequest(new GetAllWorkbookStartersRequest());
  return result;
}
